"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BindEquip',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      nowTime: Date.parse(new Date()) / 1000,
      form: {},
      numInfo: {},
      list: [],
      listLoading: true,
      listQuery: {
        page_num: 1,
        limit: 20
      },
      shopInfo: {}
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    }
  },
  mounted: function mounted() {
    this.getShop();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    getShop: function getShop() {
      var _this = this;
      this.$get('agentapi/store/merchant_store_detail').then(function (res) {
        _this.shopInfo = res;
        _this.getList();
      });
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      listQuery.store_id = this.shopInfo.store_id;
      this.$get('agentapi/device/get_store_devices', listQuery).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this2.listLoading = false;
      });
    }
  }
};